"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  primary: {
    main: "#00bcd4",
    light: "#26c6da",
    contrastText: "#fff"
  }
};
exports.default = _default;